import React from "react";
import { StyledAppIconWrapper } from "./index.styled";

const AppIconWrapper = (props) => {
  const { children, noWrap = false } = props;
  if (noWrap) return <div>{children}</div>;
  return <StyledAppIconWrapper>{children}</StyledAppIconWrapper>;
};

export default AppIconWrapper;
